import React from 'react';
import ReportHeader from './ReportHeader';
import IReportFlowModelDetail from '@Shared.Angular/@types/core/contracts/queryModel/reports/reportFlowModelDetail';

type Props = {
  isMobile: boolean;
  flowModels: IReportFlowModelDetail[];
  onHeaderClick: (flowModel: IReportFlowModelDetail) => void;
};

const ReportGroupContainer = ({
  flowModels,
  isMobile = false,
  onHeaderClick
}: Props) => {
  return (
    <div className="flow-list" ng-class="{'isMobile': $ctrl.isMobile}">
      <ul>
        {flowModels.map((flowModel) => (
          <li key={flowModel.id}>
            <ReportHeader
              flowModel={flowModel}
              isMobile={isMobile}
              onClick={onHeaderClick}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ReportGroupContainer;
